query TransactionSigningStampPrivileges{

transactionSigningStampPrivileges {
    isStampingAllowed
  }
}